if (!customElements.get('wls-hero')) {
  class WLSHero extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // Try to play all videos inside the hero section
      this.handleVideoTextColor();
      this.tryAutoplayVideos();
      // If the user interacts (e.g. touches the screen), try autoplay again
      this.addEventListener('touchstart', () => this.tryAutoplayVideos(), { once: true });
    }

    handleVideoTextColor() {
      const isMobile = window.innerWidth < 768;
      const showColorMobile = this.getAttribute('data-show-video-text-color-during-loading-mobile') === 'true';
      const showColorDesktop = this.getAttribute('data-show-video-text-color-during-loading-desktop') === 'true';
      const colorVideo = this.getAttribute('data-text-color-video');
      const colorDefault = this.getAttribute('data-text-color');
      const videos = this.querySelectorAll('.wls-hero__video video');
      if (!videos.length) return;
      // Determine if we should show the video color
      let shouldShowColor = false;
      if (isMobile && showColorMobile) shouldShowColor = true;
      if (!isMobile && showColorDesktop) shouldShowColor = true;
      if (!shouldShowColor) return;
      // Set color while loading (when the video is not playing)
      this.style.color = colorVideo;
      // When any video is played, set color to default
      videos.forEach((video) => {
        video.addEventListener(
          'playing',
          () => {
            this.style.color = colorDefault;
          },
          { once: true }
        );
      });
    }

    tryAutoplayVideos() {
      const videos = this.querySelectorAll('.wls-hero__video video');
      videos.forEach((video) => {
        if (!video.paused) return;
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      });
    }
  }
  window.customElements.define('wls-hero', WLSHero);
}
